import { render, staticRenderFns } from "./TagEditableField.vue?vue&type=template&id=08a558e2&"
import script from "./TagEditableField.vue?vue&type=script&lang=js&"
export * from "./TagEditableField.vue?vue&type=script&lang=js&"
import style0 from "./TagEditableField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TagEditableField.vue"
export default component.exports